import React, { useState, useCallback } from 'react';
// Remove useParams import as it's no longer needed here
// import { useParams } from 'react-router-dom'; 
import { motion, AnimatePresence } from 'framer-motion';
// Import the new Overview List component
import PreparationOverviewList from '../components/bonliv/preparation/PreparationOverviewList';
// Import the Detail component
import PreparationDetail from '../components/bonliv/preparation/PreparationDetail';
import { useSelector } from 'react-redux';
// Modal might still be useful for future actions
import { Modal } from 'antd'; 
import './styles/devis-animations.css'; // Reuse styles if applicable

const PreparationPage = () => {
  // refBL is no longer needed from params here
  // const { refBL } = useParams(); 
  const [currentView, setCurrentView] = useState('list'); // Default view is the overview list
  // Add state to hold the ID for the detail view
  const [selectedBonlivId, setSelectedBonlivId] = useState(null);
  const [hasUnsavedChanges, setHasUnsavedChanges] = useState(false); // Keep for potential detail view edits

  const user = useSelector(state => state.user);
  // Define permissions if needed for future actions
  // const userPermissions = {
  //   canEditPreparation: user?.CanManageExpedition || user?.IsManager, 
  // };

  // Handle unsaved changes (mainly for detail view)
  const handleChangesDetected = () => {
    setHasUnsavedChanges(true);
  };

  const handleChangesSaved = () => {
    setHasUnsavedChanges(false);
  };

  // General view change handler (can be adapted if more views are added)
  const handleViewChange = useCallback((newView, selectedData = null) => {
    // Add unsaved changes check if navigating away from detail view with changes
    if (currentView === 'detail' && hasUnsavedChanges) {
       Modal.confirm({
        title: 'Modif. non enregistrées',
        content: 'Vous avez des modifications non enregistrées. Êtes-vous sûr de vouloir quitter sans sauvegarder ?',
        okText: 'Quitter',
        cancelText: 'Rester',
        onOk: () => {
          setCurrentView(newView);
          setSelectedBonlivId(selectedData); // Update ID if relevant for new view
          setHasUnsavedChanges(false);
        },
      });
    } else {
      setCurrentView(newView);
      setSelectedBonlivId(selectedData); // Update ID if relevant for new view
    }
  }, [currentView, hasUnsavedChanges]); // Add dependencies

  // Handler passed to the Overview List
  const handleNavigateToDetails = useCallback((bonlivId) => {
    handleViewChange('detail', bonlivId);
  }, [handleViewChange]); // Dependency on handleViewChange

  // Handler passed to the Detail View
  const handleBackToList = useCallback(() => {
    handleViewChange('list', null); // Go back to list, clear selected ID
  }, [handleViewChange]); // Dependency on handleViewChange

  const handleConfirmNavigation = useCallback(() => {
    // This might be relevant if leaving the entire PreparationPage
    setHasUnsavedChanges(false);
  }, []);

  // Animation variants (reuse from Devis/Bonliv if styles match)
  const pageVariants = {
    initial: { opacity: 0, scale: 0.97 },
    animate: { opacity: 1, scale: 1, transition: { duration: 0.15, ease: [0.25, 0.1, 0.25, 1.0] } },
    exit: { opacity: 0, scale: 0.97, transition: { duration: 0.12, ease: [0.25, 0.1, 0.25, 1.0] } }
  };

  const renderView = () => {
    switch (currentView) {
      case 'detail':
        // Render the detail view, passing ID and back handler
        return <PreparationDetail
                  bonlivId={selectedBonlivId}
                  onBackToList={handleBackToList}
                  // Pass change handlers if detail view needs them
                  // onChangesDetected={handleChangesDetected}
                  // onChangesSaved={handleChangesSaved}
                />;
      case 'list':
      default:
        // Render the overview list, passing the navigation handler
        return <PreparationOverviewList onViewDetails={handleNavigateToDetails} />;
    }
  };

  return (
    // Add UnsavedChangesGuard later if forms are added to detail view
      <div className="devis-management-container"> {/* Reuse class name or create a new one */}
        <AnimatePresence mode="wait">
          <motion.div
            key={currentView} // Animation depends on view change
            initial="initial"
            animate="animate"
            exit="exit"
            variants={pageVariants}
            className="view-container"
            style={{ width: '100%', height: '100%' }}
          >
            {renderView()}
          </motion.div>
        </AnimatePresence>
      </div>
  );
};

export default PreparationPage; 